import { Link } from "react-router-dom";
import type { Replay } from "@/mocks/replays";

interface ReplayCardProps {
  replay: Replay;
}

export default function ReplayCard({ replay }: ReplayCardProps) {
  return (
    <Link
      to={`/detail/${replay.matchId}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full h-40 md:h-44 overflow-hidden bg-secondary-100">
        <img
          src={replay.cover}
          alt={`${replay.title} 精彩回放封面`}
          title={`${replay.home} vs ${replay.away} 足球回放`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
        <span className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded-md bg-black/60 text-white text-xs font-label">
          {replay.duration}
        </span>
        <span className="absolute bottom-2.5 left-2.5 inline-flex items-center gap-1 text-white text-xs">
          <i className="ri-play-circle-fill text-base" /> {replay.plays} 次播放
        </span>
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-11 h-11 rounded-full bg-white/85 flex items-center justify-center text-primary-700 opacity-0 group-hover:opacity-100 transition-opacity">
            <i className="ri-play-fill text-xl" />
          </span>
        </span>
      </div>

      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs font-medium text-primary-700 bg-primary-100 px-2 py-0.5 rounded-md whitespace-nowrap">
            {replay.leagueName}
          </span>
          <span className="text-xs text-foreground-400">{replay.date}</span>
        </div>
        <h3 className="text-sm md:text-[15px] font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {replay.title}
        </h3>
        <div className="flex items-center justify-between mt-3">
          <span className="text-xs text-foreground-500 truncate">
            {replay.home} vs {replay.away}
          </span>
          <span className="font-label text-sm font-semibold text-accent-600 whitespace-nowrap">
            {replay.score}
          </span>
        </div>
      </div>
    </Link>
  );
}